import React from "react";
import img from "../../../Assets/quality/quality.png";
import CountUp from "../common/CountUp";

const Quality = () => {
  const stats = [
    {
      count: 180,
      title: "Premium Agricultural Products",
      description: "Wide range of fertilizers designed for every crop and soil",
    },
    {
      count: 10000,
      title: "Happy Farmers Served",
      description:
        " Trusted by farmers for consistent quality and improved productivity",
    },
    {
      count: 15,
      title: "Years Industry Experience",
      description:
        " Delivering reliable agricultural solutions with proven results over years",
    },
    {
      count: 500,
      title: "Successful Farming Solutions",
      description:
        " Innovative fertilizer solutions tailored to diverse farming needs effectively",
    },
  ];

  return (
    <div className="w-full px-4 sm:px-6 md:px-10 py-4 sm:py-8 bg-gradient bg-gradient-to-b from-yellow-50 to-yellow-50/20">
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 w-full items-start">
        <div className="flex flex-col  w-full">
          <p className="text-[#92AD36] text-sm font-semibold tracking-wide uppercase">
            Quality That Delivers
          </p>
          <h2 className="text-2xl md:text-4xl font-serif  text-[#232323] mt-4 leading-relaxed">
            Driving Growth With Trusted Fertilizer Solutions Worldwide
          </h2>
          <p className="text-base text-[#1E1E1E] mt-4 leading-relaxed">
            We take pride in delivering high-quality fertilizer solutions that
            empower farmers. Our commitment and consistent performance has
            helped us achieve measurable success across diverse agricultural
            practices.
          </p>
        </div>
        <img
          src={img}
          alt="image"
          className="w-full object-cover rounded-2xl h-[240px]"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-6 mt-8">
        {stats.map((item, index) => (
          <div key={index}>
            <h3 className="text-4xl md:text-5xl font-bold font-['Times_New_Roman'] text-[#6E892D]">
              <CountUp target={item.count} />+
            </h3>
            <p className="font-semibold mt-2 text-base tracking-wide">
              {item.title}
            </p>
            <p className="text-sm text-[#1E1E1E] mt-2 tracking-wide leading-relaxed">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Quality;
